<template>
  <el-form ref="ref_textBookForm" :model="textBookForm" :rules="textBookRules" label-width="140px">
    <el-form-item label="所属科目" prop="subjectId">
      <GSelect v-model="textBookForm.subjectId" :options="selectOptionsSubject" :placeholder="'请选择科目'" />
    </el-form-item>
    <el-form-item label="教材名称" prop="teachingName">
      <el-input v-model="textBookForm.teachingName" :maxlength="30" placeholder="请输入教材名称" />
    </el-form-item>
    <el-form-item label="教材类型" prop="teachingType">
      <GSelect v-model="textBookForm.teachingType" :options="[{value:'SYSTEMTEACHING',label:'系统教材'}]" :placeholder="'请选择教材类型'" />
    </el-form-item>
    <el-form-item label="教材英文名称" prop="teachingEnName">
      <el-input v-model="textBookForm.teachingEnName" maxlength="30" placeholder="请输入教材英文名称" />
    </el-form-item>
    <el-form-item label="上传教材封面" prop="filePath">
      <theme-upload-avatar :code="'dc' + 'Img'" :file-list.sync="textBookForm.filePathList" />
    </el-form-item>
    <el-form-item label="上传教材大纲图片" prop="teachingPath">
      <theme-upload-avatar :code="'dc' + 'Img'" :file-list.sync="textBookForm.fileList" />
    </el-form-item>
    <el-form-item label="推荐年级" prop="gradeCode">
      <el-select v-model="textBookForm.gradeCode" placeholder="请选择推荐年级" clearable style="width: 100%;">
        <el-option
          v-for="item in gradeOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="最小月龄范围" prop="minBabyAge" v-if="textBookForm.gradeCode && textBookForm.gradeCode !== null && textBookForm.gradeCode !== ''">
      <el-select v-model="textBookForm.minBabyAge" placeholder="请选择" clearable style="margin-right: 20px;">
        <el-option
          v-for="item in babyAgeOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
      <el-select v-model="textBookForm.minBabyMonth" placeholder="请选择" clearable>
        <el-option
          v-for="item in babyMonthOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="最大月龄范围" prop="maxBabyAge" v-if="textBookForm.gradeCode && textBookForm.gradeCode !== null && textBookForm.gradeCode !== ''">
      <el-select v-model="textBookForm.maxBabyAge" placeholder="请选择" clearable style="margin-right: 20px;">
        <el-option
          v-for="item in babyAgeOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
      <el-select v-model="textBookForm.maxBabyMonth" placeholder="请选择" clearable>
        <el-option
          v-for="item in babyMonthOptions"
          :key="item.dicCode"
          :label="item.dicName"
          :value="item.dicCode"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="实体书价格" prop="bookPrice">
      <el-input v-model="textBookForm.bookPrice" maxlength="200" placeholder="请输入金额" onkeyup="value = value.replace(/[^\d.]/g,'')">
        <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
      </el-input>
    </el-form-item>
    <el-form-item label="APP课程价格" prop="teachingPrice">
      <el-input v-model="textBookForm.teachingPrice" maxlength="200" placeholder="请输入金额" onkeyup="value = value.replace(/[^\d.]/g,'')">
        <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
      </el-input>
    </el-form-item>
    <el-form-item label="套餐价格" prop="setmealPrice">
      <el-input v-model="textBookForm.setmealPrice" maxlength="200" placeholder="请输入金额" onkeyup="value = value.replace(/[^\d.]/g,'')">
        <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
      </el-input>
    </el-form-item>
    <el-form-item label="教材等级" prop="teachingGrade">
      <GSelect v-model="textBookForm.teachingGrade" :options="selectOptionsLevel" :placeholder="'请选择教材类型'" />
    </el-form-item>

    <el-form-item label="备注" prop="remark">
      <el-input v-model="textBookForm.remark" maxlength="200" show-word-limit type="textarea" :autosize="{ minRows: 4, maxRows: 8}" placeholder="请输入备注" />
    </el-form-item>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import themeUploadAvatar from '../courseManagement/components/themeUploadAvatar.vue'
import { getDictoryInfoByCode } from '@api/api_common'
export default {
  name: 'EditPgae',
  components: { themeUploadAvatar },
  props: {
    textBookForm: {
      type: Object,
      default: () => {

      }
    },
    timestamp: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      gradeOptions:[],
      babyAgeOptions:[],
      babyMonthOptions:[],
      textBookRules: {
        subjectName: [{ required: true, message: '请选择科目', trigger: 'blur' }],
        teachingEnName: [{ required: true, message: '请输入教材英文名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }],
        teachingPrice: [{ required: true, message: '请输入app价格', trigger: 'blur' }],
        teachingType: [{ required: true, message: '请选择教材类型', trigger: 'change' }],
        teachingName: [{ required: true, message: '请选择教材名称', trigger: 'blur' }],
        bookPrice: [{ required: true, message: '请输入实体书价格', trigger: 'blur' }],
        teachingGrade: [{ required: true, message: '请输入教材等级', trigger: 'blur' }],
        setmealPrice: [{ required: true, message: '请输入套餐价格', trigger: 'blur' }],
        remark: [{ message: '请输入备注', trigger: 'blur' }],
        subjectId: [
          { required: true, message: '请选择所属科目', trigger: 'change' }
        ],
        textBook: [
          { required: true, message: '请选择教材', trigger: 'change' }
        ],
        teachingPath: [
          { required: true, message: '教材封面不能为空', trigger: 'change' }
        ],
        filePath: [
          { required: true, message: '教材大纲图片不能为空', trigger: 'change' }
        ],
        gradeCode: [{ required: true, message: '请选择推荐年级', trigger: 'blur' }],
        minBabyAge: [{ required: true, message: '请输入最小月龄范围', trigger: 'blur' }],
        maxBabyAge: [{ required: true, message: '请输入最大月龄范围', trigger: 'blur' }],
      }
    }
  },
  computed: {
    ...mapState('commonModule', ['orgAreaTree']),
    ...mapState('commonModule', ['selectOptionsLevel', 'selectOptionsSubject','gradeOptions']),
    // ...mapState('gardenManagement', ['textBookRules']),
    fileList: function() {
      return this.textBookForm.fileList
    },
    filePathList: function() {
      return this.textBookForm.filePathList
    }
  },
  watch: {
    fileList: function(val) {
      if (!val) {
        return
      } else {
        this.textBookForm.teachingPath = val[0].url
      }
    },
    filePathList: function(val) {
      if (!val) {
        return
      } else {
        this.textBookForm.filePath = val[0].url
      }
    }
  },
  beforeDestroy() {
    this.$refs.ref_textBookForm.resetFields()
  },
   created () {
    getDictoryInfoByCode('GRADE_TYPE').then(res => { this.gradeOptions = res })
    getDictoryInfoByCode('BABY_AGE').then(res => { this.babyAgeOptions = res })
    getDictoryInfoByCode('BABY_MONTH').then(res => { this.babyMonthOptions = res })
  },
  methods: {
    
  }
}
</script>
<style>
</style>
